<template>
  <div class="preach__container">
    <div class="preach__molds-container">
      <div class="mold__wrapper">
        <div
          class="mold__item"
          :class="{
            active: typeId === item.id
          }"
          v-for="item in moldList"
          :key="item.id"
          :data-typeid="item.id"
          @click="moldOnClick"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="preach__company-select-container">
      <div class="company-select__wrapper">
        <div class="check-result-container" v-if="selections.length > 0">
          <div class="result-list-container">
            <div class="reulst__item" v-for="(item, index) in selections" :key="index">
              <p class="item__text">{{ item.name }}</p>
              <div class="item__close-bt" @click="onDel" :data-id="item.id"></div>
            </div>
          </div>
          <div class="result-submit" @click="moreForm">确定</div>
        </div>
        <div class="company-select__title">
          每个公司最多可以选择两家公司进行宣讲，第三家公司由材料在线官方进行选择。
        </div>
        <div class="company-select__main" v-if="company && company.length > 0">
          <div class="main__item" v-for="store in company" :key="store.id">
            <div class="item__inner">
              <div class="item__logo">
                <img :src="store.logo | parseImage" alt="" />
              </div>
              <div class="item__info">
                <div class="info__base">
                  <div class="base__name">{{ store.name }}</div>
                  <div class="base__preach-info">
                    已宣讲：<strong>{{ store.surplus_num }}</strong
                    >次 | 剩余：<strong>{{ store.frequency }}</strong
                    >次
                  </div>
                  <div
                    class="base__add"
                    @click="
                      selections.some(item => Number(item.id) === Number(store.id))
                        ? onDel($event)
                        : onAdd($event)
                    "
                    :data-id="store.id"
                    :data-name="store.name"
                    :class="{
                      disable: selections.some(item => Number(item.id) === Number(store.id))
                    }"
                  >
                    {{
                      selections.some(item => Number(item.id) === Number(store.id))
                        ? "已添加"
                        : "添加"
                    }}
                  </div>
                </div>
                <div class="info__summary">
                  {{ store.content }}
                </div>
                <div class="wacth-btn" v-if="userInfo && (userInfo.type == 1 || userInfo.type == 4)" @click="onWacth(store)">
                  查看企业宣讲视频
                </div>
              </div>
            </div>
          </div>
        </div>
        <Empty v-else hint="暂无商家"></Empty>
      </div>
    </div>
    <el-dialog title="联合宣讲预约" :visible.sync="showDetailForm">
      <el-form :model="form" :rules="rules" ref="apForm">
        <el-form-item prop="name">
          <el-input placeholder="联系人" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input placeholder="联系电话" v-model="form.phone"></el-input>
        </el-form-item>
        <div class="two-mix">
          <el-form-item prop="date">
            <el-date-picker
              v-model="form.date"
              type="date"
              placeholder="预约日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="time">
            <el-time-select
              class="el-form-item-for-time"
              v-model="form.time"
              :picker-options="{
                start: '10:00',
                step: '00:30',
                end: '17:30'
              }"
              placeholder="预约时间"
            >
            </el-time-select>
          </el-form-item>
        </div>
        <el-form-item prop="company">
          <el-input placeholder="公司名称" v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item prop="company_address">
          <el-input placeholder="公司地址" v-model="form.company_address"></el-input>
        </el-form-item>
        <el-form-item prop="man_num">
          <el-input placeholder="预计现场人数" v-model="form.man_num"></el-input>
        </el-form-item>
        <el-form-item prop="remarks">
          <el-input placeholder="宣讲备注" type="textarea" v-model="form.remarks"></el-input>
        </el-form-item>
        <el-form-item class="bt__wrapper">
          <el-button type="cancel" @click="onCancel">取消</el-button>
          <el-button type="submit" :loading="loading.submit" @click="onSubmit">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Empty from '@/pages/common/empty.vue';
import { mapState } from 'vuex';

let wrapperZindex;
let footerZindex;

export default {
  components: {
    Empty,
  },
  props: {
    moldList: {
      type: Array,
      default: () => [],
    },
    company: {
      type: Array,
      default: () => [],
    },
    typeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selections: [],
      form: {
        name: '',
        phone: '',
        company: '',
        company_address: '',
        pro_time: '',
        man_num: '',
        remarks: '',
        storeArr: [],
        date: '',
        time: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: '请填写联系人',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '请填写联系电话',
            trigger: 'blur',
          },
          {
            pattern: /^0{0,1}(1)[0-9]{10}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
        ],
        company: [
          {
            required: true,
            message: '请填写公司名称',
            trigger: 'blur',
          },
        ],
        company_address: [
          {
            required: true,
            message: '请填写公司地址',
            trigger: 'blur',
          },
        ],
        man_num: [
          {
            required: true,
            message: '请填写预计到场人数',
            trigger: 'blur',
          },
        ],
        date: [
          {
            required: true,
            message: '请选择宣讲日期',
            trigger: 'change',
          },
        ],
        time: [
          {
            required: true,
            message: '请选择具体时间',
            trigger: 'change',
          },
        ],
      },
      showDetailForm: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      loading: {
        submit: false,
      },
    };
  },
  computed: mapState({
    userInfo: ({ user: { info } }) => info,
  }),
  watch: {
    selections(val) {
      this.form.storeArr = val.map((item) => item.id);
    },
    // base-bone__wrapper
    showDetailForm(val) {
      document.querySelector('.base-bone__wrapper').style.zIndex = val ? 'auto' : wrapperZindex;
      document.querySelector('.footer-wrapper-container').style.zIndex = val ? '-1' : footerZindex;
    },
  },
  mounted() {
    this.$nextTick(() => {
      wrapperZindex = window.getComputedStyle(document.querySelector('.base-bone__wrapper')).zIndex;
      footerZindex = window.getComputedStyle(document.querySelector('.footer-wrapper-container'))
        .zIndex;
    });
  },
  methods: {
    moldOnClick(e) {
      const { typeid } = e.target.dataset;
      this.$emit('moldClick', typeid);
    },
    onDel(e) {
      const data = e.currentTarget.dataset;
      const temp = this.selections;
      this.selections = temp.filter((item) => Number(item.id) !== Number(data.id));
    },
    onAdd(e) {
      const data = e.currentTarget.dataset;
      if (this.selections.length < 2) {
        this.selections.push({
          name: data.name,
          id: data.id,
        });
      } else {
        this.$message({
          type: 'error',
          message: '最多只能选择两家公司',
        });
      }
    },
    moreForm() {
      if (this.form.storeArr.length < 2) {
        this.$message({
          type: 'error',
          message: '请至少选择两家公司',
        });
      } else {
        this.showDetailForm = true;
      }
    },
    onCancel() {},
    onSubmit() {
      const that = this;
      that.$refs.apForm.validate((valid) => {
        if (valid) {
          that.loading.submit = true;
          const postData = that.form;
          postData.pro_time = new Date(`${that.form.date} ${that.form.time}`).getTime() / 1000;
          that.$http
            .post('html/Propaganda/addPropaganda', postData)
            .then(() => {
              that.showDetailForm = false;
              that.$message({
                type: 'success',
                message: '预约成功',
              });
            })
            .finally(() => {
              that.loading.submit = false;
              that.$refs.apForm.resetFields();
              that.selections = [];
            });
        }
      });
    },
    onWacth(store) {
      // console.log(store, 66)
      if(store.past_video_url) {
        this.$http.post('html/store/lookPastVideo', {
          id: store.id,
        });
        window.open(store.past_video_url)
      }else {
        this.$message({
          type: 'error',
          message: '该商家还没有上传视频',
        });
      }
    },
  },
};
</script>
<style lang="scss">
  .preach__container {
    .main__item {
      height: 10.5vw !important;
    }
    .wacth-btn {
      background: #fabe00;
      line-height: 1.6vw;
      width: 7.95vw;
      text-align: center;
      border-radius: 1.2vw;
      color: #000;
      margin-top: 1vw;
      font-size: 0.73vw;
    }
  }
  
</style>
